/* unplugin-vue-components disabled */import script from "./MenuManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuManagement.vue?vue&type=script&lang=ts&setup=true"

import "./MenuManagement.vue?vue&type=style&index=0&id=10398914&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10398914"]])

export default __exports__